import { render, staticRenderFns } from "./RiskPermitWork.vue?vue&type=template&id=374408ce&scoped=true&"
import script from "./RiskPermitWork.vue?vue&type=script&lang=js&"
export * from "./RiskPermitWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374408ce",
  null
  
)

export default component.exports